/**
 * Footer groups — CLAUDE.md §6.
 *
 * Closed on a phone, open on anything with room. <details> is open-by-default
 * in markup so the links are always there for a crawler and for anyone without
 * JavaScript; this only decides whether they start folded.
 */
(function () {
  var groups = Array.prototype.slice.call(document.querySelectorAll('.fgroup'));
  if (!groups.length) return;

  /* The signup is not one of the groups.
     It used to be folded into a <details> on a phone like the link columns,
     on the reasoning that nobody scrolls that far to sign up — which is
     circular: a form behind a closed accordion is a form nobody can decide
     about. The link lists still fold, because a list of links is a thing you
     go looking for. An offer is a thing you have to be shown. */

  var wide = window.matchMedia('(min-width: 720px)');

  function apply() {
    groups.forEach(function (group) {
      group.open = wide.matches;
    });
  }

  apply();
  if (wide.addEventListener) wide.addEventListener('change', apply);
})();
